if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();

        // ModalDialog は media-modal に対して「どこをクリックしても閉じる」listener を
        // バブリング段階で貼っている。矢印はその手前（キャプチャ段階）で拾って伝播を止め、
        // モーダルを閉じずに画像だけを送る。
        this.addEventListener(
          'pointerup',
          (event) => {
            const nav = event.target.closest('.js-modal-nav');
            if (!nav) return;
            event.stopPropagation();
            this.stepMedia(nav.classList.contains('product-media-modal__nav--next') ||
              nav.classList.contains('product-media-modal__swipe-nav--next') ? 1 : -1);
          },
          true
        );

        // キーボードの左右でも送れるようにする
        this.addEventListener('keydown', (event) => {
          if (event.code === 'ArrowRight') {
            event.preventDefault();
            this.stepMedia(1);
          } else if (event.code === 'ArrowLeft') {
            event.preventDefault();
            this.stepMedia(-1);
          }
        });

        // スワイプ（慣性で複数枚流れる）に追従して枚数表示と active を更新する
        this.track?.addEventListener('scroll', () => {
          if (this.scrollTimer) clearTimeout(this.scrollTimer);
          this.scrollTimer = setTimeout(() => this.syncState(), 80);
        });
      }

      get track() {
        return this.querySelector('.product-media-modal__content');
      }

      get mediaItems() {
        const track = this.track;
        if (!track) return [];
        return Array.from(track.children).filter((child) => child.hasAttribute('data-media-id'));
      }

      // いま画面に出ているのが何枚目か。スクロール位置から求める
      get activeIndex() {
        const track = this.track;
        const items = this.mediaItems;
        if (!track || !items.length) return 0;
        const slideWidth = track.clientWidth || 1;
        const index = Math.round(track.scrollLeft / slideWidth);
        return Math.min(Math.max(index, 0), items.length - 1);
      }

      scrollToIndex(index, behavior = 'smooth') {
        const track = this.track;
        if (!track) return;
        track.scrollTo({ left: index * track.clientWidth, behavior });
      }

      // ボタン送りは1枚ずつ。端まで行ったら反対側へ回る
      stepMedia(direction) {
        const items = this.mediaItems;
        if (items.length < 2) return;
        const next = (this.activeIndex + direction + items.length) % items.length;
        this.scrollToIndex(next);
        // 端をまたぐ移動は smooth だと大きく流れるので、表示だけ先に合わせる
        this.syncState(next);
      }

      syncState(forcedIndex) {
        const items = this.mediaItems;
        if (!items.length) return;
        const index = forcedIndex ?? this.activeIndex;

        items.forEach((item, i) => item.classList.toggle('active', i === index));

        const current = this.querySelector('[data-modal-current]');
        const total = this.querySelector('[data-modal-total]');
        if (current) current.textContent = index + 1;
        if (total) total.textContent = items.length;

        const item = items[index];
        if (item && item.nodeName === 'DEFERRED-MEDIA') {
          const template = item.querySelector('template');
          if (template && template.content.querySelector('.js-youtube')) item.loadContent();
        }
      }

      hide() {
        // 拡大表示で送った先の画像を、閉じたあとのギャラリーにも引き継ぐ
        this.syncGalleryToActiveMedia();
        super.hide();
      }

      syncGalleryToActiveMedia() {
        const item = this.mediaItems[this.activeIndex];
        const mediaId = item?.getAttribute('data-media-id');
        const sectionId = this.dataset.section;
        if (!mediaId || !sectionId) return;

        const gallery = document.getElementById(`MediaGallery-${sectionId}`);
        gallery?.setActiveMedia?.(`${sectionId}-${mediaId}`, false);
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        const openedMediaId = this.openedBy?.getAttribute('data-media-id');
        const items = this.mediaItems;
        if (!items.length) return;

        let index = items.findIndex((item) => item.getAttribute('data-media-id') === openedMediaId);
        if (index === -1) index = 0;

        // 開いた直後は幅が確定していないことがあるので、描画を1フレーム待ってから合わせる
        requestAnimationFrame(() => {
          this.scrollToIndex(index, 'instant');
          this.syncState(index);
        });
      }
    }
  );
}
